import * as z from "zod";
import { hsaAnswer } from "../hsa-answer";
import { hsaHandoffSurveyState } from "./types";

// Stateless: the client holds the answer map in memory and sends the full
// accumulated set each call, so the server walks without persisting anything.
export const getHandoffSurveyGroupInput = z.object({
  sessionToken: z.string().uuid(),
  answers: z.record(z.string(), hsaAnswer),
});

export const getHandoffSurveyGroupOutput = z.object({
  state: hsaHandoffSurveyState,
});
